module.exports = __webpack_public_path__ + "img/profile.563b2889.jpg";